module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "addcreditSection"
    }
  }, [_c('div', {
    staticClass: "content bg-blue-grey-100 p-30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12 m-b-10"
  }, [_c('p', {
    staticClass: "font-size-16"
  }, [_vm._v(_vm._s(_vm.$t("billing.addcredit.labels.textGuide")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('form-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPrice),
      expression: "currentPrice"
    }],
    staticClass: "form-control form-control-lg",
    on: {
      "change": function($event) {
        _vm.currentPrice = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.priceList), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.key) + "\n            "), (item.key !== 'Custom') ? _c('span', [_vm._v(_vm._s(_vm.$t("billing.currencies.thb")))]) : _vm._e()])
  }))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.currentPrice.key === 'Custom') ? _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('customPrice')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPrice.value),
      expression: "currentPrice.value"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.currentPrice.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPrice.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.$t("billing.currencies.thb")))])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "help-guide grey-500"
  }, [_c('span', {
    staticClass: "red-600"
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t("billing.addcredit.labels.remark")) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12 m-t-15"
  }, [_c('Paypal-checkout', {
    attrs: {
      "buttonStyle": _vm.buttonStyle,
      "validate": _vm.validatePayButton,
      "credit": _vm.selectedCredit,
      "dev": _vm.paypalDevEnv
    }
  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('modal', {
    ref: "paymentInformationFormModal",
    staticClass: "modal-primary"
  }, [_c('h4', {
    staticClass: "modal-title",
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("billing.labels.paymentInformation")))]), _vm._v(" "), _c('payment-information-form', {
    ref: "paymentInformationForm",
    attrs: {
      "team": _vm.team,
      "credit": _vm.selectedCredit
    },
    on: {
      "complete": _vm.onPaymentInformationFormComplete,
      "cancel": _vm.onPaymentInformationFormCancel
    },
    slot: "body"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12 m-t-20"
  }, [_c('div', {
    staticClass: "payment-logos"
  }, [_c('a', {
    attrs: {
      "href": "https://www.paypal.com/webapps/mpp/paypal-popup",
      "title": "How PayPal Works",
      "onclick": "javascript:window.open('https://www.paypal.com/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/logo-center/9_bdg_secured_by_pp_2line.png",
      "border": "0",
      "alt": "Secured by PayPal"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "pull-xs-right",
    attrs: {
      "src": "/static/images/creditcard.png",
      "alt": "Mc visa acceptance"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39a54c8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/payments/BillingCreditPayPal.vue
// module id = 522
// module chunks = 1